import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Polyline, { points: "20 6 9 17 4 12", stroke: `${color}` })
    }
  );
};
Icon.displayName = "Check";
const Check = memo(themed(Icon));
export {
  Check
};
//# sourceMappingURL=check.js.map
